//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'OBRI',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
      },
      defaultJson:{
        'sumLabel':'近期心肌梗死、血细胞比容＜30%、血肌酐＞1.5mg/dl、糖尿病'
      },
      hasScore: false,
      disabled: false,
      title:'',
      text:''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = form.item1+form.item2+form.item3+form.item4
        if (res==0) {
          self.title='低危'
          self.text='3个月和12个月内出血风险评估：2%和3%'
        }else if (res <3) {
          self.title='中危'
          self.text='3个月和12个月内出血风险评估：5%和12%'
        }else if (res >=3) {
          self.title='高危'
          self.text='3个月和12个月内出血风险评估：23%和48%'
        }
        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/OBRI.vue